import * as React from 'react';
import { toLocalDateString } from '../../../../utils/date-utils';
import { DeliveryShipmentAction, EndShipmentAction, StartShipmentAction } from '../../../../transportation/models/shipments/shipment-action';

interface ICustomerDeliverProps {
    stop : DeliveryShipmentAction;
    index: number;
}

interface IOriginProps {
    origin: StartShipmentAction;
    index: number;
}

interface IDestinationProps {
    destination: EndShipmentAction;
    index: number;
}

const ImportCustomerDeliverRow = (props : ICustomerDeliverProps) => {

    return  <tr key={ props.stop.id }>
                <td>{ props.index }</td>
                <td>{ props.stop.name }</td>
                <td>{ props.stop.distance }</td>
                <td>{ props.stop.travelTime }</td>
                <td>{`${ props.stop.address.addressLine1 } ${ props.stop.address.city }, ${ props.stop.address.stateProvince }` }</td>
                <td>{ props.stop.orders.length }</td>
                <td>
                    { 
                        props.stop.actionTime 
                            ? toLocalDateString(props.stop.actionTime.local, props.stop.address.timeZoneId) 
                            : ''
                    }
                </td>
        </tr>;
};

const ImportOriginRow = (props : IOriginProps) => {

    return  <tr key={ props.origin.id }>
                <td className="table-cell-center" colSpan={7}>
                    Originating from &nbsp;
                    { props.origin.name } &nbsp; 
                    {`${ props.origin.address.addressLine1 } ${ props.origin.address.city }, ${ props.origin.address.stateProvince }` } &nbsp; on &nbsp;
                    { props.origin.actionTime
                        ? toLocalDateString(props.origin.actionTime.local, props.origin.address.timeZoneId)
                        : ''
                    }
                </td>
        </tr>;
};

const ImportDestinationRow = (props : IDestinationProps) => {

    return  <tr key={ props.destination.id }>
                <td>{ props.index }</td>
                <td>{ props.destination.name }</td>
                <td>{ props.destination.distance }</td>
                <td>{ props.destination.travelTime }</td>
                <td>
                    {`${ props.destination.address.addressLine1 } ${ props.destination.address.city }, ${ props.destination.address.stateProvince }` }
                </td>
                <td></td>
                <td>
                    { 
                        props.destination.actionTime
                            ? toLocalDateString(props.destination.actionTime.local, props.destination.address.timeZoneId) 
                            : ''
                    }
                </td>
        </tr>;
};

export { 
    ImportCustomerDeliverRow,
    ImportOriginRow,
    ImportDestinationRow
};
